<template>
  <layout>
    <div v-if="type !== 'xs'">
      <div class="p-8 bg-white flex justify-between">
        <div class="text-xl font-medium text-gray-900 pt-1">Settings</div>
      </div>
      <div
        class="flex flex-col pt-6 px-8 bg-white h-full border-t border-gray-200"
      >
        <div
          class="space-y-8 divide-y divide-gray-200 sm:space-y-5 w-full lg:w-3/4 2xl:w-1/2"
        >
          <div class="space-y-6 sm:space-y-5">
            <div class="space-y-8 sm:space-y-5 w-full">
              <div class="flex justify-between">
                <div class="text-base font-medium text-gray-900 pt-1">
                  Company settings
                </div>
              </div>
            </div>

            <div class="space-y-6 sm:space-y-5">
              <div
                class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:pt-6 sm:border-t sm:border-gray-200"
              >
                <label
                  for="company_name"
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Name</label
                >
                <div class="mt-1 sm:col-span-2 sm:mt-0">
                  <input
                    id="company_name"
                    name="company_name"
                    type="text"
                    autocomplete="company_name"
                    v-model="customer.company_name"
                    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                  />
                  <p
                    class="mt-1 text-xs text-red-600"
                    id="company_name-error"
                    v-if="errors?.company_name"
                  >
                    {{ errors.company_name }}
                  </p>
                </div>
              </div>
            </div>

            <div
              class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:pt-5 sm:border-t sm:border-gray-200"
            >
              <div>
                <label
                  for="api_key"
                  class="block text-sm font-medium text-gray-700"
                  >API Key</label
                >
                <p class="max-w-2xl text-sm text-gray-500">
                  Use this key to authenticate API requests.
                </p>
              </div>
              <div class="mt-1 flex rounded-md sm:col-span-2 sm:mt-0 shadow-sm">
                <div
                  class="relative flex flex-grow items-stretch focus-within:z-10"
                >
                  <input
                    type="text"
                    name="api_key"
                    id="api_key"
                    class="block w-full rounded-none rounded-l-md border-gray-300 pr-10 focus:border-brand-900 focus:ring-brand-900 sm:text-sm disabled:bg-gray-100"
                    disabled
                    v-model="customer.api_key"
                  />
                  <div
                    class="absolute inset-y-0 right-0 flex items-center pr-3"
                  >
                    <check
                      v-if="isCopied"
                      class="h-5 w-5 text-gray-500 cursor-pointer"
                      aria-hidden="true"
                    />
                    <copy-six
                      v-else
                      class="h-5 w-5 text-gray-500 cursor-pointer"
                      aria-hidden="true"
                      @click="handleCopyToClipboard"
                    />
                  </div>
                </div>
                <button
                  type="button"
                  class="text-center w-28 relative -ml-px items-center space-x-2 rounded-r-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:border-gray-300 focus:outline-none focus:ring-0 focus:ring-0"
                  @click="handleApiToken"
                >
                  <span v-if="generatingApiToken"
                    ><loading-spinner class="mx-auto"
                  /></span>
                  <span v-else>{{
                    customer.api_key ? "Regenerate" : "Generate"
                  }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="space-y-6 pt-8 sm:space-y-5 sm:pt-10">
            <div>
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                Webhook Information
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Fill in url and secret to activate webhook.
              </p>
            </div>
            <div class="space-y-6 sm:space-y-5">
              <div
                class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >URL</label
                >
                <div class="mt-1 sm:col-span-2 sm:mt-0">
                  <input
                    id="webhook_url"
                    name="webhook_url"
                    type="text"
                    autocomplete="webhook_url"
                    v-model="customer.webhook_url"
                    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                  />
                  <p
                    class="mt-1 text-xs text-red-600"
                    id="webhook_url-error"
                    v-if="errors?.webhook_url"
                  >
                    {{ errors.webhook_url }}
                  </p>
                </div>
              </div>
            </div>
            <div class="space-y-6 sm:space-y-5">
              <div
                class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                  >Secret</label
                >
                <div class="mt-1 sm:col-span-2 sm:mt-0">
                  <input
                    id="webhook_secret"
                    name="webhook_secret"
                    type="text"
                    autocomplete="webhook_secret"
                    v-model="customer.webhook_secret"
                    class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                  />
                  <p
                    class="mt-1 text-xs text-red-600"
                    id="webhook_secret-error"
                    v-if="errors?.webhook_secret"
                  >
                    {{ errors.webhook_secret }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="pt-5 mt-5 w-full lg:w-3/4 2xl:w-1/2 sm:border-t sm:border-gray-200"
        >
          <div class="flex justify-end">
            <primary-button
              label="Save"
              @click="handleSave"
              :loading="saving"
            />
          </div>
        </div>
      </div>
      <simple-alert-modal
        v-if="showApiKeyAlert"
        :open="showApiKeyAlert"
        @confirm="handleConfirm"
        @cancel="handleCancel"
      >
        <template v-slot:title>Regenerate API key</template>
        <template v-slot:description
          >Regenerating the API key will make previous integrations unusable,
          make sure to replace them with the new API Key.
        </template>
        <template v-slot:confirmation>Regenerate </template>
      </simple-alert-modal>
    </div>
    <div v-else class="h-[100dvh] landscape:h-screen bg-white">
      <div
        class="sticky top-0 space-y-1 pb-4 pt-6 px-4 sm:p-6 bg-white flex-col space-y-2 items-center justify-between border-b border-b-gray-200"
      >
        <ArrowNarrowLeft
          class="w-6 sm:w-0 sm:hidden -ml-0.5 text-gray-900"
          @click="handleBack"
        />
        <div class="flex items-center justify-between">
          <h1 class="text-gray-900 text-xl font-medium">Customer</h1>
        </div>
      </div>

      <div>
        <div
          class="flex flex-col pb-4 pt-6 px-4 sm:p-6 bg-white h-full border-t border-gray-200"
        >
          <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 w-full">
            <div class="space-y-6 sm:space-y-5">
              <div class="space-y-8 sm:space-y-5 w-full">
                <div class="flex justify-between">
                  <div class="text-base font-medium text-gray-900 pt-1">
                    Settings
                  </div>
                </div>
              </div>

              <div class="space-y-6 sm:space-y-5">
                <div
                  class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:pt-6 sm:border-t sm:border-gray-200"
                >
                  <label
                    for="company_name"
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >Name</label
                  >
                  <div class="mt-1 sm:col-span-2 sm:mt-0">
                    <input
                      id="company_name"
                      name="company_name"
                      type="text"
                      autocomplete="company_name"
                      v-model="customer.company_name"
                      class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                    />
                    <p
                      class="mt-1 text-xs text-red-600"
                      id="company_name-error"
                      v-if="errors?.company_name"
                    >
                      {{ errors.company_name }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:pt-5 sm:border-t sm:border-gray-200"
              >
                <div>
                  <label
                    for="api_key"
                    class="block text-sm font-medium text-gray-700"
                    >API Key</label
                  >
                  <p class="max-w-2xl text-sm text-gray-500">
                    Use this key to authenticate API requests.
                  </p>
                </div>
                <div
                  class="mt-1 flex rounded-md sm:col-span-2 sm:mt-0 shadow-sm"
                >
                  <div
                    class="relative flex flex-grow items-stretch focus-within:z-10"
                  >
                    <input
                      type="text"
                      name="api_key"
                      id="api_key"
                      class="block w-full rounded-none rounded-l-md border-gray-300 pr-10 focus:border-brand-900 focus:ring-brand-900 sm:text-sm disabled:bg-gray-100"
                      disabled
                      v-model="customer.api_key"
                    />
                    <div
                      class="absolute inset-y-0 right-0 flex items-center pr-3"
                    >
                      <check
                        v-if="isCopied"
                        class="h-5 w-5 text-gray-500 cursor-pointer"
                        aria-hidden="true"
                      />
                      <copy-six
                        v-else
                        class="h-5 w-5 text-gray-500 cursor-pointer"
                        aria-hidden="true"
                        @click="handleCopyToClipboard"
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    class="text-center w-28 relative -ml-px items-center space-x-2 rounded-r-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:border-gray-300 focus:outline-none focus:ring-0 focus:ring-0"
                    @click="handleApiToken"
                  >
                    <span v-if="generatingApiToken"
                      ><loading-spinner class="mx-auto"
                    /></span>
                    <span v-else>{{
                      customer.api_key ? "Regenerate" : "Generate"
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="space-y-6 pt-8 sm:space-y-5 sm:pt-10">
              <div>
                <h3 class="text-lg font-medium leading-6 text-gray-900">
                  Webhook Information
                </h3>
                <p class="mt-1 max-w-2xl text-sm text-gray-500">
                  Fill in url and secret to activate webhook.
                </p>
              </div>
              <div class="space-y-6 sm:space-y-5">
                <div
                  class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="first-name"
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >URL</label
                  >
                  <div class="mt-1 sm:col-span-2 sm:mt-0">
                    <input
                      id="webhook_url"
                      name="webhook_url"
                      type="text"
                      autocomplete="webhook_url"
                      v-model="customer.webhook_url"
                      class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                    />
                    <p
                      class="mt-1 text-xs text-red-600"
                      id="webhook_url-error"
                      v-if="errors?.webhook_url"
                    >
                      {{ errors.webhook_url }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="space-y-6 sm:space-y-5">
                <div
                  class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="first-name"
                    class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                    >Secret</label
                  >
                  <div class="mt-1 sm:col-span-2 sm:mt-0">
                    <input
                      id="webhook_secret"
                      name="webhook_secret"
                      type="text"
                      autocomplete="webhook_secret"
                      v-model="customer.webhook_secret"
                      class="block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-900 focus:ring-brand-900 sm:text-sm"
                    />
                    <p
                      class="mt-1 text-xs text-red-600"
                      id="webhook_secret-error"
                      v-if="errors?.webhook_secret"
                    >
                      {{ errors.webhook_secret }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="pt-5 mt-5 w-full lg:w-3/4 2xl:w-1/2 sm:border-t sm:border-gray-200"
          >
            <div class="flex justify-end">
              <primary-button
                label="Save"
                @click="handleSave"
                :loading="saving"
              />
            </div>
          </div>
        </div>
        <simple-alert-modal
          v-if="showApiKeyAlert"
          :open="showApiKeyAlert"
          @confirm="handleConfirm"
          @cancel="handleCancel"
        >
          <template v-slot:title>Regenerate API key</template>
          <template v-slot:description
            >Regenerating the API key will make previous integrations unusable,
            make sure to replace them with the new API Key.
          </template>
          <template v-slot:confirmation>Regenerate </template>
        </simple-alert-modal>
      </div>
    </div>
  </layout>
</template>

<script setup>
import Layout from "@/Tailwind/Pages/Settings";
import { computed, defineProps, ref } from "vue";
import { useForm } from "@inertiajs/vue3";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton";
import CopySix from "@/Tailwind/Icon/CopySix";
import route from "ziggy-js";
import LoadingSpinner from "@/Tailwind/Components/LoadingSpinner";
import Check from "@/Tailwind/Icon/Check";
import SimpleAlertModal from "@/Tailwind/Components/SimpleAlertModal";
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";
import ArrowNarrowLeft from "@/Tailwind/Icon/ArrowNarrowLeft.vue";
import { router } from "@inertiajs/vue3";

const { type } = useBreakpoints();

const props = defineProps({
  customer: {
    type: Object,
  },
});

const saving = ref(false);
const generatingApiToken = ref(false);
const copied = ref(false);
const timer = ref(3);
const showApiKeyAlert = ref(false);

const apiKey = computed(() => props.customer?.api_key);
const errors = computed(() => customer.errors);
const isCopied = computed(() => copied.value);

const customer = useForm({
  company_name: props.customer.company_name,
  api_key: apiKey,
  webhook_url: props.customer.webhook?.url,
  webhook_secret: props.customer.webhook?.secret,
});

function handleBack() {
  router.visit(route("settings.organisation.index"));
}

function handleSave() {
  customer.put(route("settings.user.customer.update", props.customer), {
    onStart: () => (saving.value = true),
    onFinish: () => (saving.value = false),
  });
}

function handleApiToken() {
  showApiKeyAlert.value = true;
}

function handleCopyToClipboard() {
  navigator.clipboard.writeText(apiKey.value).then(() => {
    copied.value = true;
    startTimer();
  });
}

function startTimer() {
  const interval = setInterval(() => {
    if (timer.value === 0) {
      clearInterval(interval);
      copied.value = false;
    } else {
      timer.value--;
    }
  }, 1000);
}

function handleConfirm() {
  customer.post(route("settings.user.customer.api_token", props.customer), {
    onStart: () => (generatingApiToken.value = true),
    onFinish: () => {
      generatingApiToken.value = false;
      showApiKeyAlert.value = false;
    },
  });
}

function handleCancel() {
  showApiKeyAlert.value = false;
}
</script>
